<template>
  <div class="dialog-wrapper" :class="{ open }">
    <div class="modal" @click="onClickModal"></div>
    <div class="outer">
      <div @click.stop class="dialog" :style="{ width }">
        <div v-if="!hideTitle" class="header">
          <div class="dialog-title">{{ title }}</div>
          <div
            v-if="showClose"
            @click="$emit('close')"
            class="dialog-close"
          ></div>
        </div>
        <div class="body">
          <slot> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["close"],
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "标题",
    },
    width: {
      type: String,
      default: "80%",
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickModal() {
      if (this.closeOnClickModal) this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  position: fixed;
  pointer-events: none;
  &.open {
    pointer-events: all;
    .modal {
      opacity: 1;
      z-index: 1000;
    }
    .outer {
      opacity: 1;
      z-index: 1000;
      .dialog {
        pointer-events: all;
        transform: translateY(0);
        transition: 0.1s;
        z-index: 1001;
      }
    }
  }

  .modal {
    position: fixed;
    opacity: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: -1;
    transition: 0.2s;
  }
  .outer {
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    .dialog {
      transform: translateY(30px) scale(0.9);
      margin: 0 auto;
      background: #fff;
      padding: 10px;
      border-radius: 0.2rem;
      box-sizing: border-box;
      .header {
        height: 4rem;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        .dialog-title {
          font-size: 1.4rem;
          letter-spacing: 0.2em;
          color: #000;
        }
        .dialog-close {
          position: absolute;
          right: 0;
          top: 0rem;
          height: 1rem;
          width: 1rem;
          background: url(../../assets/close.png) no-repeat center;
          background-size: contain;
          cursor: pointer;
        }
      }
      .body {
        width: 100%;
      }
    }
  }
}
</style>
